/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { DataSetSetupValueDto } from './DataSetSetupValueDto';
import {
    DataSetSetupValueDtoFromJSON,
    DataSetSetupValueDtoFromJSONTyped,
    DataSetSetupValueDtoToJSON,
} from './DataSetSetupValueDto';
import type { EnumerationDataPointDto } from './EnumerationDataPointDto';
import {
    EnumerationDataPointDtoFromJSON,
    EnumerationDataPointDtoFromJSONTyped,
    EnumerationDataPointDtoToJSON,
} from './EnumerationDataPointDto';
import type { EnumerationEvaluationParameterDto } from './EnumerationEvaluationParameterDto';
import {
    EnumerationEvaluationParameterDtoFromJSON,
    EnumerationEvaluationParameterDtoFromJSONTyped,
    EnumerationEvaluationParameterDtoToJSON,
} from './EnumerationEvaluationParameterDto';
import type { MedicalSystemCatalogDto } from './MedicalSystemCatalogDto';
import {
    MedicalSystemCatalogDtoFromJSON,
    MedicalSystemCatalogDtoFromJSONTyped,
    MedicalSystemCatalogDtoToJSON,
} from './MedicalSystemCatalogDto';
import type { QaEquipmentItemGroupDto } from './QaEquipmentItemGroupDto';
import {
    QaEquipmentItemGroupDtoFromJSON,
    QaEquipmentItemGroupDtoFromJSONTyped,
    QaEquipmentItemGroupDtoToJSON,
} from './QaEquipmentItemGroupDto';
import type { TaskTypeDescription } from './TaskTypeDescription';
import {
    TaskTypeDescriptionFromJSON,
    TaskTypeDescriptionFromJSONTyped,
    TaskTypeDescriptionToJSON,
} from './TaskTypeDescription';

/**
 * 
 * @export
 * @interface EnumerationDataSetDto
 */
export interface EnumerationDataSetDto {
    /**
     * 
     * @type {string}
     * @memberof EnumerationDataSetDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof EnumerationDataSetDto
     */
    combinationHash: string;
    /**
     * 
     * @type {number}
     * @memberof EnumerationDataSetDto
     */
    numberOfResults: number;
    /**
     * 
     * @type {TaskTypeDescription}
     * @memberof EnumerationDataSetDto
     */
    taskType: TaskTypeDescription;
    /**
     * 
     * @type {string}
     * @memberof EnumerationDataSetDto
     */
    jobName: string;
    /**
     * 
     * @type {string}
     * @memberof EnumerationDataSetDto
     */
    jobConfigurationIuid: string;
    /**
     * 
     * @type {string}
     * @memberof EnumerationDataSetDto
     */
    taskName: string;
    /**
     * 
     * @type {MedicalSystemCatalogDto}
     * @memberof EnumerationDataSetDto
     */
    targetSystem: MedicalSystemCatalogDto;
    /**
     * 
     * @type {Array<QaEquipmentItemGroupDto>}
     * @memberof EnumerationDataSetDto
     */
    supportSystems: Array<QaEquipmentItemGroupDto>;
    /**
     * 
     * @type {Array<DataSetSetupValueDto>}
     * @memberof EnumerationDataSetDto
     */
    targetSystemSetups: Array<DataSetSetupValueDto>;
    /**
     * 
     * @type {Array<DataSetSetupValueDto>}
     * @memberof EnumerationDataSetDto
     */
    supportSystemSetups: Array<DataSetSetupValueDto>;
    /**
     * 
     * @type {EnumerationEvaluationParameterDto}
     * @memberof EnumerationDataSetDto
     */
    evaluationParameter: EnumerationEvaluationParameterDto;
    /**
     * 
     * @type {Array<EnumerationDataPointDto>}
     * @memberof EnumerationDataSetDto
     */
    data: Array<EnumerationDataPointDto>;
    /**
     * 
     * @type {string}
     * @memberof EnumerationDataSetDto
     */
    $type?: EnumerationDataSetDtoTypeEnum;
}


/**
 * @export
 */
export const EnumerationDataSetDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedResultsDtoEnumerationDataSetDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Results.Dto.EnumerationDataSetDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type EnumerationDataSetDtoTypeEnum = typeof EnumerationDataSetDtoTypeEnum[keyof typeof EnumerationDataSetDtoTypeEnum];


/**
 * Check if a given object implements the EnumerationDataSetDto interface.
 */
export function instanceOfEnumerationDataSetDto(value?: unknown): value is EnumerationDataSetDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(EnumerationDataSetDtoTypeEnum)[0];
}

export function EnumerationDataSetDtoFromJSON(json: any): EnumerationDataSetDto {
    return EnumerationDataSetDtoFromJSONTyped(json, false);
}

export function EnumerationDataSetDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnumerationDataSetDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'combinationHash': json['combinationHash'],
        'numberOfResults': json['numberOfResults'],
        'taskType': TaskTypeDescriptionFromJSON(json['taskType']),
        'jobName': json['jobName'],
        'jobConfigurationIuid': json['jobConfigurationIuid'],
        'taskName': json['taskName'],
        'targetSystem': MedicalSystemCatalogDtoFromJSON(json['targetSystem']),
        'supportSystems': ((json['supportSystems'] as Array<any>).map(QaEquipmentItemGroupDtoFromJSON)),
        'targetSystemSetups': ((json['targetSystemSetups'] as Array<any>).map(DataSetSetupValueDtoFromJSON)),
        'supportSystemSetups': ((json['supportSystemSetups'] as Array<any>).map(DataSetSetupValueDtoFromJSON)),
        'evaluationParameter': EnumerationEvaluationParameterDtoFromJSON(json['evaluationParameter']),
        'data': ((json['data'] as Array<any>).map(EnumerationDataPointDtoFromJSON)),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function EnumerationDataSetDtoToJSON(value?: EnumerationDataSetDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'combinationHash': value.combinationHash,
        'numberOfResults': value.numberOfResults,
        'taskType': TaskTypeDescriptionToJSON(value.taskType),
        'jobName': value.jobName,
        'jobConfigurationIuid': value.jobConfigurationIuid,
        'taskName': value.taskName,
        'targetSystem': MedicalSystemCatalogDtoToJSON(value.targetSystem),
        'supportSystems': ((value.supportSystems as Array<any>).map(QaEquipmentItemGroupDtoToJSON)),
        'targetSystemSetups': ((value.targetSystemSetups as Array<any>).map(DataSetSetupValueDtoToJSON)),
        'supportSystemSetups': ((value.supportSystemSetups as Array<any>).map(DataSetSetupValueDtoToJSON)),
        'evaluationParameter': EnumerationEvaluationParameterDtoToJSON(value.evaluationParameter),
        'data': ((value.data as Array<any>).map(EnumerationDataPointDtoToJSON)),
        '$type': value.$type,
    });
}

